// The rating flow's words: the same words for the same thing wherever the flow shows.
export const WORDS = {
	ask: "How was it?",
	unseen: "Haven't seen it",
	unseenHint: "We won't ask about it again.",
	notInterested: "Not interested",
	notInterestedHint: "We won't recommend it.",
	nextTitle: "Next title",
	keys: "Keys: 1–9, 0 = 10 · W want to see · H haven't seen it · N not interested",
	seeTaste: "See your taste",
	keepRating: "Keep rating",
	yourTaste: "Your taste",
	picks: "Picked for you",
	picksLine: "Titles you haven't rated, closest to your taste.",
	noPicks: "No picks right now. Rate a few more to find some.",
	yourRatings: "Your ratings",
	noRatings: "Nothing rated yet.",
	ratingsFailed: "Couldn't load these titles.",
	titleUnavailable: "Title unavailable",
	showMore: "Show more",
	showFewer: "Show fewer",
	loading: "Finding titles for you…",
	failed: "Couldn't load more titles.",
	tryAgain: "Try again",
	empty: "That's every title for now.",
	saveTaste: "Save your taste",
	signUpFree: "Sign up free",
	resumeTitle: "Pick up where you left off",
	continueRating: "Continue rating",
	dismiss: "Dismiss",
	wantToSee: "Want to See",
	wantToSeeHint: "Saved to your list.",
	lastAnswered: "Last answered",
	changeIt: "Change it",
	yourAnswer: "Your answer:",
	noAnswer: "No answer now",
	clearIt: "Clear it",
	clearFailed: "Couldn't clear it. Try again.",
	backToNew: "Back to new titles",
	signUpLine: (rated: number) => `${rated} ratings, all in this browser.`,
	signUpLineLink: "Sign up to keep them",
	lockedHead: (rated: number) => `You've rated ${rated}.`,
	lockedLine: "Sign up free to keep rating. Your ratings come with you.",
	continueWithGoogle: "Continue with Google",
	haveAccount: "Have an account? Sign in",
} as const
